import type { Map as ImmutableMap } from 'immutable';

/** Tabs page path of the License overview page (`x-webPages` node path). */
export const CLOUD_LICENSING_PAGE_PATH =
  '/settings/administration/license-consumption';

/**
 * Whether a snapshot supports the new cloud licensing model.
 *
 * The API fills `licenseUsage` only for snapshots that use it (see `getSnapshots`), so its
 * presence is the whole condition.
 */
export const snapshotSupportsCloudLicensing = (
  licenseUsage: ImmutableMap<string, unknown> | null | undefined,
): boolean => licenseUsage !== null && licenseUsage !== undefined;
